import { Component, OnInit } from '@angular/core';
import { LocalDatePipe } from 'src/app/pipes/local-date.pipe';

@Component({
  selector: 'app-device-information',
  templateUrl: './device-information.component.html',
  styleUrls: ['./device-information.component.scss']
})
export class DeviceInformationComponent implements OnInit {
  dateTime: Date; size: string; agent: string; pressedNumKeyChar: null; pressedTextKeyChar = null;
  offset: number = 0; mediaDeviceInfoVideo: string = 'Loading..'; mediaDeviceInfo: string = 'Loading..';
  blutoothDevices: string = 'Loading..'; isBluetoothConnected: boolean | null = null;

  optionalServicesUuid: string = ''; gattServiceUUID = ''; characteristicUUID = ''; characteristic: any;

  constructor() { }

  ngOnInit(): void {
    const localDatePipe = new LocalDatePipe();
    this.dateTime = localDatePipe.getDeviceDate();
    this.offset = localDatePipe.getUtcOffset();
    this.size = window.innerHeight + ' X ' + window.innerWidth;
    this.agent = window.navigator.userAgent.toLowerCase();

    navigator.mediaDevices.getUserMedia({ video: true })
      .then(() => {
        this.onGetCameraDevices();
      });

    this.getBluetoothDevices();
  }

  onGetCameraDevices() {
    navigator.mediaDevices.enumerateDevices()
      .then((devices) => {
        this.mediaDeviceInfo = devices ? JSON.stringify(devices) : "NA";
        const videoDevices = devices.filter(device => device.kind === 'videoinput');
        this.mediaDeviceInfoVideo = videoDevices ? JSON.stringify(videoDevices) : "NA";
      });
  }

  getBluetoothDevices() {
    navigator.bluetooth.requestDevice({
      acceptAllDevices: true
    }).then(device => {
      if (device) {
        this.blutoothDevices = "Device: " + device.name + ", Id: " + device.id + "\n";
      }
    }).catch(error => {
      this.blutoothDevices = "Error:", error;
    });
  }

  onConnectBluetooth() {
    navigator.bluetooth.requestDevice({
      filters: [{ services: [this.optionalServicesUuid] }],
      optionalServices: [this.optionalServicesUuid] // Example BLE printer service UUID
    }).then(device => device.gatt?.connect())
      .then(server => server.getPrimaryService(this.gattServiceUUID)) // Printer main service
      .then(service => service.getCharacteristic(this.characteristicUUID)) // Writable characteristic
      .then(characteristic => {
        this.isBluetoothConnected = true;
        this.characteristic = characteristic;
      }).catch(err => {
        this.isBluetoothConnected = false;
      });
  }

  onTestPrintBluetooth() {
    if (!this.characteristic) {
      console.error("Printer characteristic not available.");
      return;
    }

    const encoder = new TextEncoder();
    const data = encoder.encode("Hello Printer\n\n");

    this.characteristic.writeValue(data)
      .then(() => console.log("Data sent to printer"))
      .catch(err => console.error("Write error:", err));
  }

  onKeyPress(event, index) {
    const charCode = (event.which) ? event.which : event.keycode;
    switch (index) {
      case 1: {
        this.pressedNumKeyChar = charCode;
      } break;
      case 2: {
        this.pressedTextKeyChar = charCode;
      } break;
    }
  }
}
